import { css } from 'lit';

export const styles = css `
  .selected {
    background-color: var(--u-select-option-selected-bg-color, color-mix(in srgb, var(--u-color-primary, rgb(103, 80, 164)) 12%, transparent));
  }
  .selected .icon,
  .selected .content {
    color: var(--u-select-option-selected-text-color, var(--u-color-primary, rgb(103, 80, 164)));
  }

  .container:not(.selected):not(.trailing-icon) .trailing {
    display: none;
  }
`;
